export default __webpack_public_path__ + "static/media/Pear_product.82b4cc4a.png";